import React from 'react';
import clsx from 'clsx';

import styles from './Branding.module.scss';
import { StandardProps } from '../../types/common';
import logo from './logo.svg';

export interface BrandingProps extends StandardProps {
  /**
   * Source file location
   */
  src?: string;

  /**
   * Alt text for image
   */
  alt?: string;

  /**
   * Type of logo: one of affiliate, partner, club, or default. Determines the size and spacing of the logo.
   */
  type?: 'affiliate' | 'partner' | 'club' | 'default';

  /**
   * URL to link to
   */
  href?: string;

  /**
   * Wordmark to display next to logo
   */
  wordmark?: string;

  /**
   * URL to link to when wordmark is clicked
   */
  wordmarkHref?: string;
}

export const Branding = ({
  className,
  style,
  src = logo,
  alt = 'Hagerty Logo',
  type = 'default',
  href = '/',
  testid = 'branding',
  wordmark,
  wordmarkHref,
}: BrandingProps): JSX.Element => {
  return (
    <div
      className={clsx(styles['hds-branding'], className)}
      style={style}
      data-testid={testid}
    >
      <a
        href={href}
        className={clsx(styles['hds-branding__logo'], {
          [styles.affiliates]: type === 'affiliate',
          [styles.clubs]: type === 'club',
          [styles.partners]: type === 'partner',
        })}
      >
        <img src={src} alt={alt} />
        {wordmark && !wordmarkHref && (
          <span className={styles['hds-branding__wordmark']}>{wordmark}</span>
        )}
      </a>
      {wordmark && wordmarkHref && (
        <span className={styles['hds-branding__wordmark']}>
          <a href={wordmarkHref}>{wordmark}</a>
        </span>
      )}
    </div>
  );
};
